export enum ValidationResultType {
  None = 0,
  Mandatory = 1,
  Recommended = 2
}

(ValidationResultType as any).__typeName = 'ValidationResultType';
